var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6228_49335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.88906 10.7672L13.2328 16.1109C14.025 16.3641 14.8734 16.5 15.75 16.5C20.3062 16.5 24 12.8062 24 8.25C24 3.69375 20.3062 0 15.75 0C11.1938 0 7.5 3.69375 7.5 8.25C7.5 9.12656 7.63594 9.975 7.88906 10.7672ZM15.75 6.375C15.75 5.87772 15.9475 5.40081 16.2992 5.04917C16.6508 4.69754 17.1277 4.5 17.625 4.5C18.1223 4.5 18.5992 4.69754 18.9508 5.04917C19.3025 5.40081 19.5 5.87772 19.5 6.375C19.5 6.87228 19.3025 7.34919 18.9508 7.70083C18.5992 8.05246 18.1223 8.25 17.625 8.25C17.1277 8.25 16.6508 8.05246 16.2992 7.70083C15.9475 7.34919 15.75 6.87228 15.75 6.375Z",
    fill: "#FFE662"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.88906 10.7676L13.2328 16.1113L11.6719 17.6723C11.4609 17.8832 11.175 18.0004 10.875 18.0004H9V19.8754C9 20.4988 8.49844 21.0004 7.875 21.0004H6V22.8754C6 23.4988 5.49844 24.0004 4.875 24.0004H1.125C0.501562 24.0004 0 23.4988 0 22.8754V19.1254C0 18.8254 0.117188 18.5395 0.328125 18.3285L7.88906 10.7676Z",
    fill: "#FFE662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6228_49335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.575acca2017d7e40d9ff330fdb7e48fc.svg";
export { ForwardRef as ReactComponent };